import { Maybe } from '../../../__generated__/globalTypes'

import minimalCampaignFragmentRawString from '../CampaignFragmentMinimal.graphql'

export const minimalCampaignFragmentString = minimalCampaignFragmentRawString

export type MinimalCampaignFragment = {
  __typename: 'Campaign'
  id: string
  name: string
  minimalLines: {
    card: Maybe<{
      id: string
      isHorizontal: boolean
      frontPreviewUrl: string
    }>
    giftVariation: Maybe<{
      defaultImageUrl: string
    }>
  }[]
}

export const isMinimalCampaignFragment = (
  fragment: any,
): fragment is MinimalCampaignFragment =>
  fragment &&
  fragment.__typename === 'Campaign' &&
  typeof fragment.id === 'string' &&
  typeof fragment.name === 'string' &&
  Array.isArray(fragment.minimalLines) &&
  fragment.minimalLines
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) =>
        accum &&
        next &&
        (next.card === null ||
          (next.card &&
            typeof next.card.id === 'string' &&
            typeof next.card.isHorizontal === 'boolean' &&
            typeof next.card.frontPreviewUrl === 'string')) &&
        (next.giftVariation === null ||
          (next.giftVariation &&
            typeof next.giftVariation.defaultImageUrl === 'string')),
      true,
    )
